define([
	"dojo/_base/declare",
	"csi/action/PopupController"
], function(declare,PopupController) {

	return declare(PopupController, {
		preProcess: function(/*Object*/params) {
			// summary: highlight row if one
			var	refNode = this.widget.getRefNode(this.refNode || this.m_element);
			if (refNode) {
				this.widget.highlight(refNode, false, true);
			}
			
			this.inherited(arguments);
		},
		
		postProcess: function(/*Boolean*/bStatus) {
			// summary: unhighlight node
			var	refNode = this.widget.getRefNode(this.refNode || this.m_element);
			if (refNode) {
				this.widget.highlight(refNode, true, true);
			}
			
			this.inherited(arguments);
		}
	});
});